export const BONUS_RECORD_HEAD_CELLS = [
  {
    id: 'created_at',
    label: 'Дата'
  },
  {
    id: 'document_number',
    label: 'ID транзакции',
  },
  {
    id: 'name',
    label: 'ФИО',
  },
  {
    id: 'customer_iin',
    label: 'ИИН'
  },
  {
    id: 'customer_id',
    label: 'Идентификационный номер клиента'
  },
  {
    id: 'mobile_phone',
    label: 'Номер моб телефона',
  },
  {
    id: 'customer_account_id',
    label: 'Лицевой счет',
  },
  {
    id: 'amount',
    label: 'Сумма'
  },
  {
    id: 'transaction_status',
    label: 'Статус'
  },
  {
    id: 'payment_transaction_id',
    label: 'ID транзакции в МПШ'
  },
];
